var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-btn'),_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('del-person-form',{on:{"emitData":_vm.createDelagatedPerson}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }